export const TestPassNumber = (pass) => {
  const regex = /^(?=.*[0-9])/;
  return pass.match(regex);
};

export const TestPassLetter = (pass) => {
  const regx = /(?=.*[a-z/A-Z])/;
  return pass.match(regx);
};

export const TestPassChar = (pass) => {
  const regx = /(?=.*[!@#$%^&*])/;
  return pass.match(regx);
};

export const specialCharList = ' @ ! # $ % ^ & *';

export const isEmailValid = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const isPhoneValid = (phone) => {
  // eslint-disable-next-line
  const re = /^[0-9\+]{1,}[0-9\-]{5,15}$/;

  return re.test(phone);
};

export const validateRegister = (password) => {
  if (password.length > 7
    && password.length < 30
    && TestPassLetter(password)
    && TestPassNumber(password)
    && TestPassChar(password)) {
    return true;
  }
  return false;
};

export const isItalianFiscalCode = (cf) => {
  const CF_REGEX = /^[A-Z]{6}\d{2}[A-EHLMPRST]\d{2}[A-Z]\d{3}[A-Z]$/i;
  return CF_REGEX.test(cf.trim());
};

export const isPodNumber = (pod) => {
  if (!pod || typeof pod !== 'string') return false;
  const POD_REGEX = /^IT\d{3}E\d{8}$/i;
  return POD_REGEX.test(pod.trim());
};
